<template>
  <div>
    <div class="my-5">
      <p class="text-center text-big">
        You have successfully created a Floor Plan Mapper Online workspace.<br />
        Please check your email to confirm the workspace creation.
      </p>
    </div>
    <div class="px-4 px-sm-5">
      <b-form-group label="Enter verification code" v-if="step === 'enter'">
        <b-input type="text" v-model="token" @keyup="onTokenEnter" />
      </b-form-group>
      <div v-if="step === 'done'" class="text-center text-big">
        <div class="display-1 ion ion-ios-checkmark-circle-outline text-center text-success mb-4"></div>
        <p class="mb-4">Your email address has been successfully confirmed.</p>
        <router-link :to="{ name: 'login' }" tag="button" class="btn btn-primary btn-block">
          Sign in
        </router-link>
      </div>
      <div class="text-danger" style="min-height: 24px">
        <p v-text="errorMessage"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'register-verification',
  data: () => ({
    step: 'enter',
    errorMessage: '',
    token: ''
  }),
  methods: {
    ...mapActions('auth', ['registerVerification']),
    onTokenEnter(e) {
      this.errorMessage = ''
      if (this.token.length >= 6) {
        this.verify(this.token)
      }
    },
    verify(token) {
      this.registerVerification({ token }).then(() => {
          this.step = 'done'
        }, (error) => {
          if (error.response && error.response.data) {
            let data = error.response.data
            if (data.message === 'verified already') {
              // replace: back would land on the code check again and send the reader here again
              this.$router.replace({ name: 'login' })
            } else if (data.errors) {
              let message = ''
              for (let field in data.errors) {
                message += data.errors[field].join(' ')
              }
              this.errorMessage = message
            } else if (data.message) {
              this.errorMessage = data.message
            }
          }
          throw error
        })
    }
  },
  mounted() {
    let token = this.$route.query.token
    if (token) {
      this.verify(token)
    }
  }
}
</script>

<style scoped></style>
